import React, {HTMLAttributes} from 'react';
import {Client} from '@/api/dto/client-profile';
import {Message} from '@/api/dto/message';
import {useAuthStore} from '@/store/auth_store';
import {NotificationLink} from '@/components/pages/notifications/links/NotificationLink';
import {SearchParam} from '@/helpers/search_params';
import PermissionsHelpers from '@/helpers/permissions_helpers';

type Props = HTMLAttributes<HTMLAnchorElement> & {
  client: Client;
  message?: Message;
  disabled? : boolean
};

export default function MessageLink({ client, message, disabled, ...props }: Props) {
  const { currentUser } = useAuthStore();

  const rosterId = client.roster?.id;
  const effectiveRoster = client.roster;

  const searchParams = `${SearchParam.PATIENT_ID}=${client.patientId}&` +
    `${SearchParam.ROSTER_ID}=${rosterId}&` +
    `${SearchParam.MESSAGE_THREAD_ID}=${message?.messageThread?.id}`;

  return !!currentUser && !!effectiveRoster && PermissionsHelpers.hasRosterAccess(currentUser, effectiveRoster) ? (
    <NotificationLink to={`/clients/profile/messages?${searchParams}`} disabled={disabled} {...props}>
        message
    </NotificationLink>
  ) : (
    <>message</>
  );
}
